export default __webpack_public_path__ + "static/media/subscribe-email.97da99ea.svg";